import homeShopRoutes from '../homeshop/routes'
export default {
  path: 'member/:memberId',
  props: true,
  components: {
    default: () =>
      import(/* webpackChunkName: "member-layout" */ '../MemberLayout.vue'),
    overlay: () =>
      import(
        /* webpackChunkName: "overlay-member-profile" */ '../views/OverlayMemberProfile'
      )
  },
  children: [
    {
      name: 'MemberHome',
      path: '',
      redirect: {
        name: 'MemberMatchHistory'
      }
    },
    {
      path: 'match-history',
      name: 'MemberMatchHistory',
      props: true,
      meta: {
        defaultTab: 'match-history'
      },
      component: () =>
        import(
          /* webpackChunkName: "member-match-history" */ '../views/MatchHistory'
        )
    },
    {
      path: 'tournament-history',
      name: 'MemberTournamentHistory',
      props: true,
      meta: {
        defaultTab: 'tournament-history'
      },
      component: () =>
        import(
          /* webpackChunkName: "member-tournament-history" */ '../views/TournamentHistory'
        )
    },
    homeShopRoutes
  ]
}
